const animations = {
  ping: 'ping 4s cubic-bezier(0, 0, 0.2, 1) infinite',
}

const keyframes = {
  ping: {
    '75%, 100%': { transform: 'scaleX(1.5) scaleY(1.75)', opacity: '0' },
  },
}

module.exports = { animations, keyframes }
